export default __webpack_public_path__ + "static/media/team6.be109ef5.png";